import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import model1 from '@/components/model1'
import model2 from '@/components/model2'
import model3 from '@/components/model3'
import czdb from '@/components/czdb'
import xxxz from '@/components/xxxz'
import AssiPage from '@/components/AssiPage'
import EndPage from '@/components/EndPage'
import vedioV1 from '@/components/vedioV1'
import vedioV2 from '@/components/vedioV2'
import dualLens from '@/components/dualLens'


Vue.use(Router)

const routes = [
  {
    path: '/home',
    name: 'home',
    component: Home
  },
  {
    path: '/model1',
    name: 'model1',
    component: model1
  },
  {
    path: '/model2',
    name: 'model2',
    component: model2
  },
  {
    path: '/model3',
    name: 'model3',
    component: model3
  },
  {
    path: '/czdb',
    name: 'czdb',
    component: czdb
  },
  {
    path: '/xxxz',
    name: 'xxxz',
    component: xxxz
  },
  {
    path: '/AssiPage',
    name: 'AssiPage',
    component: AssiPage
  },
  {
    path: '/EndPage',
    name: 'EndPage',
    component: EndPage
  },
    {
    path: '/vedioV1',
    name: 'vedioV1',
    component: vedioV1
  },
      {
    path: '/vedioV2',
    name: 'vedioV2',
    component: vedioV2
  },
  {
    path: '/dualLens',
    name: 'dualLens',
    component: dualLens
  },
  {
    path: '/',
    redirect: '/home'
  }

]

const router = new Router({
  routes: routes
})

router.beforeEach((to, from, next) => {
  if (window._hmt) {
    if (to.path) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  next()
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js